function About() {
    return (
        <section id="about" className="section about">
            
            <div className="about-container">

                <h1 className="title">
                    Hello, I'm <span className="highlight">Shreyes Tripathi</span>
                </h1>

                <p className="about-intro">
                    A multidisciplinary VFX & graphics artist crafting immersive visual experiences.
                </p>

                <div className="about-text">
                    <p>
                        I’m a multidisciplinary VFX and graphics artist with a strong passion for crafting visually compelling experiences across film, games, and digital media. With hands-on experience in industry-standard tools including Autodesk Maya, Houdini, Unreal Engine, Photoshop, Illustrator, and other creative pipelines, I specialize in transforming ideas into immersive visual realities.
                    </p>

                    <p>
                        My work sits at the intersection of technical precision and artistic storytelling. I approach every project with a balance of creativity and problem-solving — whether I’m building complex simulations, developing real-time environments, designing motion graphics, or creating polished marketing visuals.
                    </p>
                </div>

            </div>

        </section>
    );
}

export default About;